
// login
import loginBackground from './background/login-background.svg'
import loginLogo from './icons/logo-login.svg'
import usernameIcon from './icons/username-login.svg'
import passwordIcon from './icons/password-login.svg'
import eyePasswordIcon from './icons/eye-login.svg'
import user from '../assets/icons/user.svg'
import downArrow from '../assets/icons/down-arrow.svg'
import notification from '../assets/icons/notification.svg'
import book from '../assets/icons/book.svg'
import plusButton from '../assets/icons/plus.svg'
import list from './icons/list.svg'

// after login
import berger from './icons/berger.svg'
import addButton from './icons/add-icon.svg'

// navbar
import statisticsIcon from './nav/statistics.svg'
import projectInformation from './nav/projectInformation.svg'
import projectStatus from './nav/projectStatus.svg'
import report from './nav/report.svg'
import usageStatistics from './nav/usageStatistics.svg'
import setting from './nav/setting.svg'
import notification_normal from './nav/notification-normal.svg';

// icon
import download from './icons/download.svg'
import arrowTopBottom from './icons/arrow-top-and-bottom.svg'
import addForm from './icons/add-form.svg'
import editIcon from './icons/edit.svg'
import deleted from './icons/delete.svg'
import cloudIconUpload from './icons/upload.svg'
import dropdownDot from './icons/dropdownDot.svg'
import editPen from './icons/editPen.svg'
import copy from './icons/copy.svg'
import detailIcon from './icons/detailIcon.svg'
import exit from './icons/exit.svg'
import startDeleteIcons from './icons/startDeleteIcon.svg'


// alert
import draft from './alert/draft.svg'
import one from './alert/one.svg'
import two from './alert/two.svg'
import three from './alert/three.svg'
import four from './alert/four.svg'
import five from './alert/five.svg'
import six from './alert/six.svg'
import seven from './alert/seven.svg'
import eight from './alert/eight.svg'
import nine from './alert/nine.svg'
import ten from './alert/ten.svg'
import eleven from './alert/eleven.svg'
import twelve from './alert/twelve.svg'
import thirteen from './alert/thirteen.svg'
import errors from './alert/errors.svg'
import start from './alert/start.png'

export const RouteImage = {
    bg_login: loginBackground,


    // logo
    login_logo: loginLogo,

    // icons
    login_username_icon: usernameIcon,
    login_password_icon: passwordIcon,
    login_eye_icon: eyePasswordIcon,
    berger: berger,
    user: user,
    downArrow: downArrow,
    notification: notification,
    book: book,
    plusButton: plusButton,
    addButton: addButton,
    download: download,
    arrowTopBottom: arrowTopBottom,
    addForm: addForm,
    list: list,
    editIcon: editIcon,
    delete: deleted,
    cloudIconUpload: cloudIconUpload,
    dropdownDot: dropdownDot,
    editPen: editPen,
    copy: copy,
    detailIcon: detailIcon,
    exit:exit,
    startDeleteIcons:startDeleteIcons,
    notification_normal:notification_normal

}

export const navbarRouteImage = {
    statisticsIcon: statisticsIcon,
    projectInformation: projectInformation,
    projectStatus: projectStatus,
    report: report,
    usageStatistics: usageStatistics,
    setting: setting
}

export const alertImage = {
    draft,
    start,
    one,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
    nine,
    ten,
    eleven,
    twelve,
    thirteen,
    errors
}